import { Duration } from 'luxon';

import {
  EquipmentType,
  Mode,
  SpotMarketUpliftRule,
} from '@rygen/rygen-ui/model';

import { InviteCommand } from './InviteCommand';

const TYPE = 'Order';

export class OrderInviteCarriersToSpotMarketBatchCommand implements InviteCommand {
  orderIds: number[] = [];
  scacs: string[] = [];
  mode?: Mode;
  equipmentType?: EquipmentType;
  serviceType?: string;
  expirationDuration?: Duration;
  requireFuel: boolean = false;
  includeCarrierNotes: boolean = false;
  includeLocationNotes: boolean = false;
  upliftRule?: SpotMarketUpliftRule;

  constructor(opts?: Partial<OrderInviteCarriersToSpotMarketBatchCommand>) {
    if (opts?.orderIds != null) {
      this.orderIds = opts.orderIds;
    }
    if (opts?.scacs != null) {
      this.scacs = opts.scacs;
    }
    if (typeof opts?.mode === 'string') {
      this.mode = Mode[opts.mode];
    } else if (opts?.mode != null) {
      this.mode = opts.mode;
    }
    if (opts?.equipmentType != null) {
      this.equipmentType = new EquipmentType(opts.equipmentType);
    }
    if (opts?.serviceType != null) {
      this.serviceType = opts.serviceType;
    }
    if (typeof opts?.expirationDuration === 'string') {
      this.expirationDuration = Duration.fromISO(opts.expirationDuration);
    } else if (opts?.expirationDuration) {
      this.expirationDuration = opts.expirationDuration;
    }
    if (opts?.requireFuel) {
      this.requireFuel = opts.requireFuel;
    }
    if (opts?.includeCarrierNotes) {
      this.includeCarrierNotes = opts.includeCarrierNotes;
    }
    if (opts?.includeLocationNotes) {
      this.includeLocationNotes = opts.includeLocationNotes;
    }
    if (opts?.upliftRule != null) {
      this.upliftRule = new SpotMarketUpliftRule(opts.upliftRule);
    }
  }

  get type(): string {
    return TYPE;
  }

  get numLoads(): number {
    return this.orderIds.length;
  }

  static isOrderInviteCarriersToSpotMarketBatchCommand(
    obj: unknown,
  ): obj is OrderInviteCarriersToSpotMarketBatchCommand {
    return (
      !!obj &&
      (obj as OrderInviteCarriersToSpotMarketBatchCommand).type === TYPE
    );
  }

  validate() {
    if (!this.orderIds.length) {
      throw new Error('Cannot invite carriers without an order id');
    }

    return true;
  }
}
